"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var init = function (APP_ID) {
    var w = window;
    var ic = w.Intercom;
    if (typeof ic === 'function') {
        ic('reattach_activator');
        ic('update', window.intercomSettings);
    }
    else {
        var d = document;
        var i = function () {
            i.c(arguments);
        };
        i.q = [];
        i.c = function (args) {
            i.q.push(args);
        };
        w.Intercom = i;
        var s = d.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = 'https://widget.intercom.io/widget/' + APP_ID;
        var x = d.getElementsByTagName('script')[0];
        x.parentNode && x.parentNode.insertBefore(s, x);
    }
};
var Intercom = /** @class */ (function () {
    function Intercom() {
    }
    Intercom.boot = function (intercomData) {
        var _this = this;
        init(intercomData.app_id);
        if (!window.Intercom) {
            return;
        }
        var intercomSettings = {
            app_id: intercomData.app_id,
            email: intercomData.email,
            user_id: intercomData.email,
            user_hash: intercomData.user_hash,
            platform_version: intercomData.platformVersion
        };
        window.Intercom('boot', intercomSettings);
        window.Intercom('onShow', function () { return window.dispatchEvent(new CustomEvent(_this.STATE_CHANGED_EVENT, { detail: { isOpened: true } })); });
        window.Intercom('onHide', function () { return window.dispatchEvent(new CustomEvent(_this.STATE_CHANGED_EVENT, { detail: { isOpened: false } })); });
        window.Intercom('onUnreadCountChange', function (unreadCount) {
            window.dispatchEvent(new CustomEvent(_this.MESSAGE_COUNT_CHANGED_EVENT, { detail: { unreadCount: unreadCount } }));
        });
    };
    Intercom.show = function () {
        var intercom = window.Intercom;
        if (!intercom) {
            return;
        }
        intercom('show');
    };
    Intercom.showWithMessage = function (message) {
        var intercom = window.Intercom;
        if (!intercom) {
            return;
        }
        intercom('showNewMessage', message);
    };
    Intercom.hide = function () {
        var intercom = window.Intercom;
        if (!intercom) {
            return;
        }
        intercom('hide');
    };
    Intercom.STATE_CHANGED_EVENT = 'x-intercom-state-changed';
    Intercom.MESSAGE_COUNT_CHANGED_EVENT = 'x-intercom-message-count-changed';
    return Intercom;
}());
exports.default = Intercom;
